import { render, staticRenderFns } from "./AverageSpendingPerHead.vue?vue&type=template&id=6941aa25&scoped=true&"
import script from "./AverageSpendingPerHead.vue?vue&type=script&lang=js&"
export * from "./AverageSpendingPerHead.vue?vue&type=script&lang=js&"
import style0 from "./AverageSpendingPerHead.vue?vue&type=style&index=0&id=6941aa25&scoped=true&lang=css&"
import style1 from "./AverageSpendingPerHead.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6941aa25",
  null
  
)

export default component.exports